import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_project/bid-row-details/$projectId/$subProjectId")({
  component: Outlet,
});
